// extracted by mini-css-extract-plugin
export var buttonContainer = "_7t-1";
export var fontSizeSelect = "_7t-3";
export var formatSelect = "_7t-2";
export var formats = "_7t-4";
export var hidden = "_7t-5";
export var icon = "_7t-6";
export var select = "_7t-0";